const defaultView = {
  name: "defaultView",
  openPaymentURLInDiffTab: true,
  home: "RedirectHandler",
  addonsWithFakedoor: ["titan_max"],
};

export default defaultView;
